import type { DatasetQueryConfig } from '@deckspace/types';

/**
 * Centralized query key factory for @tanstack/react-query.
 *
 * Hierarchical keys allow targeted invalidation:
 *   invalidateQueries({ queryKey: queryKeys.workspaces.all })
 *   → invalidates both .list and .home
 *
 * Datasets: schema and rows cache independently because rows depend on
 * queryConfig (filter/orderBy/limit) but schema does not. SSE broadcasts
 * invalidate the `['datasets', workspaceId]` prefix, which fires for both.
 */
export const queryKeys = {
  workspaces: {
    all: ['workspaces'] as const,
    list: () => ['workspaces', 'list'] as const,
    home: () => ['workspaces', 'home-list'] as const,
  },
  workspace: {
    detail: (id: string) => ['workspace', id] as const,
  },
  datasets: {
    all: ['datasets'] as const,
    workspace: (workspaceId: string) => ['datasets', workspaceId] as const,
    schema: (workspaceId: string, name: string) =>
      ['datasets', workspaceId, name, 'schema'] as const,
    rows: (workspaceId: string, name: string, cfg?: DatasetQueryConfig) =>
      ['datasets', workspaceId, name, 'rows', cfg ?? null] as const,
  },
};
